import TagsEditorContainer from "./TagsEditorContainer";

export default TagsEditorContainer;
